/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { Label, EmptyState } from '@ba/ba-ui-carbon-toolkit';
import PropTypes from 'prop-types';
import '../stylesheets/slotEditorEmptyState.scss';

class SlotEditorEmptyState extends Component{
	constructor(props){
		super(props);
	}

	render() {
		const emptyState = this._renderEmptyState();
		const title = this.renderTitle();
		const description = this.renderDescription();
		return (
			<div className="slotEditorEmpty">
				<div className="slotEditorEmpty__container">
					{emptyState}
					{title}
					{description}
				</div>
			</div>
		);
	}

	_renderEmptyState() {
		return (
			// This surrounding div is temporary needed to hide the SVG until https://jsw.ibm.com/browse/BAUICOMMON-691 delivers an updated SVG
			<div data-html2canvas-ignore>
				<EmptyState
					type={this.props.type}
					size={'large'}>
				</EmptyState>
			</div>
		);
	}

	renderTitle() {
		if (this.props.title) {
			return (
				<Label label={this.props.title} className="slotEditorEmpty__title" />
			);
		}
		return null;
	}

	renderDescription() {
		if (this.props.description) {
			const description = this.props.description;
			return (
				<Label label={description} className="slotEditorEmpty__description" />
			);
		}
		return null;
	}
}

SlotEditorEmptyState.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	iconId: PropTypes.string,
	alignment: PropTypes.string,
	type: PropTypes.string
};

SlotEditorEmptyState.defaultProps = {
	title: null,
	iconId: null,
	description: null,
	alignment: null,
	type: 'default'
};

export default SlotEditorEmptyState;



// WEBPACK FOOTER //
// ./src/js/SlotEditorEmptyState.js